import type { AgentMessage } from "@calcplan/ai-capabilities";

const CONTROL_PREFIX = "[Controle interno do CalcPlan — não atribuir ao usuário]";

/**
 * The answer pass needs the complete human message. The execution pass does
 * not: once routing is complete, feeding the mixed text back to the planner
 * lets questions and explanations leak into operational scope. Preserve only
 * non-text attachments and replace the current text with the closed action
 * packet produced by the router.
 */
export function messagesForActionPacket(
  messages: readonly AgentMessage[],
  objective: string,
): AgentMessage[] {
  const current = messages.at(-1);
  if (!current || current.role !== "user") {
    return [{
      role: "user",
      content: [{ type: "text", text: `${CONTROL_PREFIX} ${objective}` }],
    }];
  }
  const attachments = current.content.filter((block) => block.type !== "text");
  return [
    ...messages.slice(0, -1),
    {
      role: "user",
      content: [
        ...attachments,
        {
          type: "text",
          text: `${CONTROL_PREFIX} A triagem da mensagem atual foi concluída. Processe somente o pacote fechado abaixo; perguntas e explicações da mensagem original pertencem à etapa de resposta e não são ações.\n${objective}`,
        },
      ],
    },
  ];
}
